import styled from "styled-components";

export const AdicionarUsuarioContainer = styled.div`
    transition: all 0.5 ease-in-out;
    
    .edit-user-success-step{
        h2{
            text-align: center !important;
        }
    }

    header {
        display: flex;
        justify-content: space-between;

        h2 {
            font-size: 2em;
            margin-bottom: 20px;
        }
    }

    .adicionar-usuario-modal-container {
        max-width: 650px;
        width: 100%;
    }
`;

export const AdicionarUsuarioImagem = styled.div<{url: string, letterColor: string}>`
  background: ${({ url, letterColor }) => (url ? `url(${url})` : letterColor)};
  background-size: cover;
  background-position: center;
  width: 90px;
  height: 90px;
  border-radius: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 3em;
  font-weight: 800;
  color: ${({ theme }) => theme.colors.background};
  user-select: none;
  margin-right: 10px;
  cursor: pointer;
  flex-shrink: 0
`;